import { IAppState } from '../common/state';

export function selectBreadcrumbs(state: IAppState) {
  return state.breadcrumbs;
}
